import * as z from "zod";

import { boardMeetingCommentSchema } from "./board-meeting-comment";
import { userSchema } from "./user";

export const boardMeetingCommentWithCreatedBySchema =
  boardMeetingCommentSchema.extend({
    createdBy: userSchema,
  });

export type BoardMeetingCommentWithCreatedBy = z.infer<
  typeof boardMeetingCommentWithCreatedBySchema
>;
